import { render, staticRenderFns } from "./CheckboxOptionSlot.vue?vue&type=template&id=684e4fe4&"
import script from "./CheckboxOptionSlot.vue?vue&type=script&lang=js&"
export * from "./CheckboxOptionSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports